import { render } from "./MyInputText.vue?vue&type=template&id=4dc03ce6&scoped=true"
import script from "./MyInputText.vue?vue&type=script&lang=js"
export * from "./MyInputText.vue?vue&type=script&lang=js"

import "./MyInputText.vue?vue&type=style&index=0&id=4dc03ce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc03ce6"]])

export default __exports__